export default {
  DEVICE_FAQ_HEADING: `OK {{patientName}}, let’s check these things first:`,
  DEVICE_FAQ_INTRO_FIRST: `First, let's make sure that:`,
  DEVICE_FAQ_INTRO_ACCORDION: `Start by checking this`,
  DEVICE_FAQ_WIFI_RECOMMENDATION: `You are near your WiFi router.`,
  DEVICE_FAQ_STREAMING_RECOMMENDATION: `Nobody in your house is streaming video or playing games.`,
  DEVICE_FAQ_VOLUME_RECOMMENDATION: `Your volume is unmuted and turned up.`,
  DEVICE_FAQ_PERMISSIONS_RECOMMENDATION: `Choose <strong>Allow</strong> any time your web browser prompts you to enable your microphone. `,
  DEVICE_FAQ_CONTENT: `Remember that the application might need a second to respond, so please be patient as you try these additional steps.`,
  DEVICE_FAQ_HELP_HEADING: `OK {{patientName}} - let's figure this out`,

  // Used in both fullFaq and deviceFaq
  FAQ_SIGNPOST: `Still having issues? Try rebooting your device, or call your practice.`,
  FAQ_SIGNPOST_LINK: `Copy link to this visit`,
};
